import React, { useEffect } from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';

import yup from '../../../utility/yup';
import { Modal } from '../../../components';
import { useActionDispatcher } from '../../../hooks/index';
import UploadMediaFromUrlForm from '../tab-media/UploadMediaFromUrlForm';
import { uploadMediaFromURLRequest } from '../../../store/modules/articles/actions';
import { useSelector } from 'react-redux';
import { uploadMediaFromUrlState } from '../../../store/modules/articles/selectors';
import { PlusCircleIcon } from '../../../components/icon/solid';

type Props = {
  closeHandler: () => void;
  open: boolean;
};

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  form: {
    paddingBottom: 56,
  },
  buttonLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    fontSize: 16,
    marginRight: 5,
  },
}));

const schema = yup.object().shape({
  title: yup.string().required(),
  url: yup.string().url('URL must be a valid').required(),
});

const UploadFromUrlAction = ({ closeHandler, open }: Props) => {
  const classes = useStyles();
  const { loading, error, form } = useSelector(uploadMediaFromUrlState);

  useEffect(() => {
    if (!form && !loading && !error) {
      closeHandler();
    }
  }, [loading, error, closeHandler, form]);

  return (
    <>
      <Modal
        form={{
          data: form,
          validationSchema: schema,
          onSubmit: useActionDispatcher(uploadMediaFromURLRequest),
          submitTitle: <span className={classes.buttonLabel}><PlusCircleIcon className={classes.icon} /> Upload</span>,
          loading,

        }}
        open={open}
        onCloseHandler={closeHandler}
        title="Upload Video from URL"
        hideCancel
      >
        <div className={classes.form}>
          <UploadMediaFromUrlForm />
        </div>
      </Modal>
    </>
  );
};

export default UploadFromUrlAction;
